import React, { Fragment } from 'react';

import { StyledLargeText, StyledSmallText } from './UscModalFormHeaderStyles';

var _ref2 = React.createElement(
  StyledSmallText,
  null,
  'Hi! Welcome to Dormify.'
);

var UscModalFormHeader = function UscModalFormHeader(_ref) {
  var discountOff = _ref.discountOff;

  return React.createElement(
    Fragment,
    null,
    _ref2,
    React.createElement(
      StyledLargeText,
      null,
      'Get ' + discountOff + ' off!'
    )
  );
};

export default UscModalFormHeader;